/* ===========================================================================
 * WHOSE REQUESTS APPLY THE MOMENT THEY ARE FILED.
 *
 * The server decides it, and the screens have to know too: a "My requests"
 * tab for someone whose requests never wait for anyone is a list of things
 * already done, and a notification about one is a note to self. The page used
 * to re-derive the rule as `role === 'ADMIN'`, which missed HR and ignored the
 * permission half, so it lives here once for both sides.
 * ======================================================================== */

/** Anything with `has` — a Set of keys, or a wrapper over a caller's grants. */
export interface HeldPermissions {
  has(key: string): boolean;
}

/**
 * A correction filed by this person applies at once. Whole-company reach is a
 * role (scope) fact; being ALLOWED to decide is `corrections.approve`, so a
 * custom HR-based role that lost it files a PENDING request like anyone else.
 */
export function correctionAutoApplies(role: string | undefined, held: HeldPermissions): boolean {
  return (role === 'ADMIN' || role === 'HR') && held.has('corrections.approve');
}

/** A letter requested by this person is issued at once. */
export function letterAutoApproves(held: HeldPermissions): boolean {
  return held.has('letters.create');
}
